export enum EAnalysesType {
  BIOMETRY = "biometry",
  QUALITY = "quality",
  DOCUMENTS = "documents",
}
